export class ContatoAnexo {
  id: number;
  idContato: number;
  idAnexo: number;
  descricao: string;
  arquivo: string;
  dataHora: Date;
  nomeUsuario: string;
  statusExc: boolean;
  dataHoraExc?: Date;
  nomeUsuarioExc: string;
}
